<app-back-button></app-back-button>

<div class="details-container" *ngIf="wellRequest$ | async as wellRequest">
  <app-well-details-header [wellRequest]="wellRequest"></app-well-details-header>
  <div class="cancel-button" *ngIf="canCancel()">
    <app-cancel-request-button *ngIf="!wellRequest?.isInRts" [wellRequestId]="wellRequest?.id"></app-cancel-request-button>
  </div>

  <app-well-details-admin></app-well-details-admin>
  <mat-divider></mat-divider>
  <app-well-details-info [wellRequest]="wellRequest"></app-well-details-info>
  <div *ngIf="isCanEdit">
    <form class="form" [formGroup]="form">
      <div class="well-info-item">
        <div style="margin: 0px 0px -28px 50px; position: relative;">
          <mat-icon matTooltip="A group name selection is needed to enable admin list" style="font-size: 21px; color: blue">info</mat-icon>
        </div>
        <app-chip #chipComponent label="Admin"
                  placeholder="Enter admin..."
                  (selectedItemsEvent)="adminSelectionChanged($event)"
                  (removeEvent)="adminRemoveChanged($event)"
                  [count]=5
                  [dataSource]="filteredAdmins"
                  [selectedSourceItems]="selectedAdmins"
                  formControlName="admin"
                  app-autocomplete-validator
                  [required]="true">
        </app-chip>
      </div>
    </form>
  </div>
  <app-well-details-comments></app-well-details-comments>
  <app-submit-cancel-button *ngIf="isCanEdit" [disableSubmit]="isDisableSubmit" [form]="form" [hideSubmit]="true" (submitedEvent)="submitHandler($event)"></app-submit-cancel-button>
  
  <div *ngIf="canRequestChanges">
    <form class="form" [formGroup]="form">
      <div>
        <div>
          <div style="margin:0px 0px -28px 50px;">
            <mat-icon matTooltip="A group name selection is needed to enable admin list" style="font-size: 21px; color: blue">info</mat-icon>
          </div>
          <app-chip #chipComponent label="Admin"
            placeholder="Enter admin..."
            [dataSource]="filteredAdmins"
            [selectedSourceItems]="selectedAdmins"
            [isRemovableFunc]="isAdminRemovableForChangeRequest"
            [count]=5
            formControlName="admin"
            app-autocomplete-validator
            [required]="true"
            (selectedItemsEvent)="onAdminSelectedForChangeRequest($event)"
            (removeEvent)="onAdminRemovedForChangeRequest($event)">
          </app-chip>
        </div>
        <mat-divider></mat-divider>
      </div>
      <div class="well-info-item">
        <mat-label for="comments">Comments<span class="validation-hint">&nbsp;*Required when request changes</span></mat-label><br />
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="comments">
          <textarea matInput
            formControlName="comments"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="6"
            cdkAutosizeMaxRows="6"
            maxlength="250"
            (keydown.enter)="onCommentsEnter($event)">
          </textarea>
        </mat-form-field>
        <!-- remove for now since logic is being changed
        <p class="info-message">* For wells synced with <strong>Enverus</strong>, changes remain available for <strong>30 days</strong></p> -->
      </div>
      <div class="form-buttons">
        <button mat-raised-button type="button" color="accent" class="submit-button accent-button" [disabled]="!form.get('comments')?.value?.trim() || isFormDisabled || selectedAdmins.length === 0" (click)="requestChangesSubmit()">Request Changes</button>
      </div>
    </form>
  </div>

  <div class="form-buttons" *ngIf="canAdminEdit">
    <button mat-raised-button type="button" color="primary" class="submit-button" (click)="editRequest()">Edit</button>
  </div>
</div>
